import React from 'react';
import { connect } from 'react-redux';
import { DBCheckBoxObjective, ObjectiveFlag, DBCheckBoxComment } from '_components';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css'

class ObservationPosturePeds extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteSection id='obj_obs_posture_peds' name='Posture' level={2} noChildPadding={false}>
                <div className={styles.form_row}>
                    <div className={styles.gap}>
                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSNBOS'
                            className={styles.checkbox}
                            label='NBOS'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>


                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSWBOS'
                            className={styles.checkbox}
                            label='WBOS'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>


                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSANTPELVTILT'
                            className={styles.checkbox}
                            label='Anterior pelvic tilt'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>

                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSPOSPELVTILT'
                            className={styles.checkbox}
                            label='Posterior pelvic tilt'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>

                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSSWAYBACK'
                            className={styles.checkbox}
                            label='Sway back'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>

                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSINCLORDOSIS'
                            className={styles.checkbox}
                            label='Increased lardasis'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>

                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSINCKYPHOSIS'
                            className={styles.checkbox}
                            label='Increased kyphasis'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>


                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSSPINEWODEV'
                            className={styles.checkbox}
                            label='Spine without deviation'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>


                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSSPINEWDEV'
                            className={styles.checkbox}
                            label='Spine with deviation (i.e. scoliosis)'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>


                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSCROUCH'
                            className={styles.checkbox}
                            label='Crouch'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>


                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSHYPEREX'
                            className={styles.checkbox}
                            label='Hyperextension of knees'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>


                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSOVERPRON'
                            className={styles.checkbox}
                            label='Over-pronation'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>


                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSOVERSUP'
                            className={styles.checkbox}
                            label='Over-supination'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>


                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSWINGING'
                            className={styles.checkbox}
                            label='Winging scapulae'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>


                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSFORWARDHEAD'
                            className={styles.checkbox}
                            label='Forward head'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>


                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSROUNDSHOULDER'
                            className={styles.checkbox}
                            label='Rounded shoulders'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>


                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSSHOULDERELRIGHT'
                            className={styles.checkbox}
                            label='Shoulder elevation right'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>

                <div className={styles.form_row}>
                    <div className={styles.gap}>


                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSSHOULDERELLEFT'
                            className={styles.checkbox}
                            label='Shoulder elevation left'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>


                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSASYMMETRIES'
                            className={styles.checkbox}
                            label='Asymmetries'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>


                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPPOSOTHER'
                            className={styles.checkbox}
                            label='Other'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let opno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEPEDS)
        .find(key => (state.entities.notes.PTOBJECTIVEPEDS[key].OPEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEPEDS[key].OPNTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        opno: opno
    };
}

const connectedObservationPosturePeds = connect(mapStateToProps)(ObservationPosturePeds);
export { connectedObservationPosturePeds as ObservationPosturePeds };


